import { ProductCarousel } from '@johnlewispartnership/wtr-content-component-library';
import type { CmsProductCarouselProps } from '@johnlewispartnership/wtr-content-component-library';
import { useFeatureFlags } from '@johnlewispartnership/wtr-website-decisioner-client/express';

import { useFavouritesService } from 'services/favourites/useFavouritesService';
import { useTrolleyService } from 'services/trolley/useTrolleyService';
import { AEM_CONTENT_RENDERER_CLIENT_ENABLE_PRODUCT_CAROUSEL } from 'constants/feature-flags';
import { usePreloadedData } from 'renderer/context/preloadedDataContext';

const ProductCarouselWrapper = ({ items, ...rest }: CmsProductCarouselProps) => {
  const enableProductCarousel =
    useFeatureFlags()[AEM_CONTENT_RENDERER_CLIENT_ENABLE_PRODUCT_CAROUSEL];
  const { favourites, toggleFavourite } = useFavouritesService();
  const { trolley, isReady, addTrolleyItem, updateTrolleyItem } = useTrolleyService();
  const { conflicts } = usePreloadedData();

  if (!enableProductCarousel) {
    return null;
  }

  const enrichedItems = items.map(item => {
    const trolleyMatchedItem = trolley?.trolleyItems?.find(
      trolleyItem => trolleyItem.lineNumber === item.searchProduct.lineNumber,
    );

    return {
      ...item,
      searchProduct: {
        ...item.searchProduct,
        favourite: !!favourites[item.searchProduct.lineNumber || ''],
      },
      trolleyQuantity: trolleyMatchedItem?.quantity,
    };
  });

  return (
    <ProductCarousel
      {...rest}
      items={enrichedItems}
      onFavouriteClick={toggleFavourite}
      onAddToTrolley={isReady ? addTrolleyItem : undefined}
      onUpdateTrolleyQuantity={isReady ? updateTrolleyItem : undefined}
      conflicts={conflicts}
    />
  );
};

export default ProductCarouselWrapper;
